import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Primary/secondary editorial buttons with arrow micro-interaction.
export const ArrowButton = ({ to, href, children, variant = "solid", className = "", onClick, type, testid }) => {
  const base =
    "group inline-flex items-center gap-3 px-7 py-4 font-sans text-sm tracking-wide uppercase rounded-sm transition-colors duration-300 select-none";
  const styles = {
    solid: "bg-bottle-green text-cream hover:bg-secondary-green",
    outline: "border border-dark-text/25 text-dark-text hover:bg-bottle-green hover:text-cream hover:border-bottle-green",
    light: "bg-cream text-bottle-green hover:bg-warm-beige",
    ghostLight: "border border-cream/30 text-cream hover:bg-cream hover:text-bottle-green",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" strokeWidth={1.6} />
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls} onClick={onClick}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls}>{inner}</a>;
  return <button type={type || "button"} data-testid={testid} className={cls} onClick={onClick}>{inner}</button>;
};

// Inline text link with animated underline + arrow.
export const ArrowLink = ({ to, children, className = "", light = false, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 font-mono text-xs tracking-[0.18em] uppercase ${light ? "text-cream" : "text-bottle-green"} ${className}`}
  >
    <span className="link-underline">{children}</span>
    <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.8} />
  </Link>
);
